import { TimeslotId } from "../timeslots.types";

export function createTimeslotId(n: number): TimeslotId {
  if (n < 0 || n > 335) throw new Error("Invalid timeslot id");
  return n as TimeslotId;
}

export default createTimeslotId;

